module.exports = __webpack_public_path__ + "img/generic_car4.730ff577.png";